import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSaveWorkspacePageMutation } from '@/features/workspaces/workspacesApi';
import { showToast } from '@/features/toast/toastSlice';
import { useWorkspaceContext } from '@/context/WorkspaceContext';

export const WorkspaceSaveButton = () => {
	const {
		dealId,
		clientId,
		relationshipCompanyId,
		draftHtml,
		savedHtml,
		isUnsaved,
		isBusy,
		handleSaved,
	} = useWorkspaceContext();
	const dispatch = useDispatch();
	const [saveWorkspacePage, { isLoading: isSaving }] = useSaveWorkspacePageMutation();

	const handleSave = async () => {
		try {
			await saveWorkspacePage({
				dealId,
				clientId,
				relationshipCompanyId,
				html: draftHtml ?? savedHtml,
			}).unwrap();
			handleSaved();
			dispatch(
				showToast({
					message: 'Workspace version saved successfully!',
					success: true,
				}),
			);
		} catch {
			dispatch(
				showToast({
					message: 'Error saving workspace. Please try again.',
					error: true,
				}),
			);
		}
	};

	return (
		<Button variant='contained' onClick={handleSave} disabled={!isUnsaved || isBusy || isSaving}>
			{isSaving ? <CircularProgress size={18} color='inherit' /> : 'Save'}
		</Button>
	);
};

export default WorkspaceSaveButton;
WorkspaceSaveButton.displayName = 'WorkspaceSaveButton';
